import React, { useEffect, useState } from 'react';
import { config } from '../../../../config';
import { messages } from "../../../../../src/messages";
import axiosApi from '../../../../core/interceptor/interceptor';

export default function ResetPassword(props) {
    let data_ = props.data;

    const [formSubmitted, setFormSubmitted] = useState(false);
    const [formData, setFormData] = useState({
        password: '',
        confirm_password: '',
        send_email: false,
    });
    const [checkbox, setCheckbox] = useState(false);

    useEffect(() => {
        handleChange({
            target: {
                name: 'send_email',
                value: checkbox,
            }
        });
    }, [checkbox]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setFormSubmitted(true);
        if ((!(formData.password || '').trim() &&
            !(formData.confirm_password || '').trim()) ||
            (formData["password"] !== formData["confirm_password"])) {
            return;
        }
        updatePassword();
    }

    const handleChange = (e) => {
        setFormData((prevData) => ({
            ...prevData,
            [e.target.name]: e.target.value,
        }));
    }

    function updatePassword() {
        axiosApi.post(`${config.apiUrl}/users/${data_.user_type}/update-password`, {
            ...formData,
            'id': data_.id,
        }).then(() => {
            props.closeModal(false);
        }).catch((err) => {

        });
    }
    return <>
        <form onSubmit={handleSubmit}>
            <div className="modal">
                <div className="modal-header">
                    <h2>Reset Password - {`${data_.first_name} ${data_.last_name}`}</h2>
                    <p>Enter a new password</p>
                    <span className="close" onClick={() => props.closeModal(false)} >
                        <img src="/static/media/close.c18327ca.svg" alt='close-modal'/>
                    </span>
                </div>
                <div className="resetPassword-wrapper">

                    <div className="input-field">
                        <label>Enter Password</label>
                        <input type="password" name="password" value={formData.password} onChange={handleChange} />
                        {!(formData.password || '').trim() && formSubmitted && <span className="error">{messages['emptyPassword']}</span>}
                        {((formData.password || '').trim().length < 6 && (formData.password || '').trim().length > 0) && formSubmitted && <span className="error">{messages['passwordLength']}</span>}
                    </div>
                    <div className="input-field">
                        <label>Confirm Password</label>
                        <input type="password" name="confirm_password" value={formData.confirm_password} onChange={handleChange} />
                        {(formData.password || '').trim() !== (formData.confirm_password || '').trim() && formSubmitted && <span className="error">{messages['confirmPasswordError']}</span>}
                        {!(formData.password || '').trim() && formSubmitted && <span className="error">{messages['emptyconfirmPassword']}</span>}
                    </div>
                    <div className="inner-blk-reset-password">
                        <label className="checkbox">
                            <input type="checkbox" name="send_email" value={checkbox} checked={checkbox} onChange={() => setCheckbox(o => !o)} />
                            <span className="checkmark"></span>
                        </label>
                        <span className="label-text">Send Email</span>
                    </div>
                </div>
                <div className="modal-footer d-flex">
                    <button className="cancel-btn" onClick={(e) => {
                        e.preventDefault();
                        props.closeModal(false);
                    }}>Cancel</button>
                    <button>Save</button>
                </div>
            </div>
        </form>
    </>
}